// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_hw-a";
export var fulfillmentFormRail = "_hw-9";
export var headerTitleRow = "_hw-c";
export var orderDetailsWrapper = "_hw-7";
export var orderLinkTrigger = "_hw-2";
export var paymentInformationGrid = "_hw-h";
export var paymentSummaryColumn = "_hw-i";
export var shipmentContainer = "_hw-b";
export var shipmentDetailsMainPane = "_hw-8";
export var shipmentNavigationCard = "_hw-5";
export var shipmentNavigationRail = "_hw-3";
export var shipmentNavigationRailHeader = "_hw-4";
export var shipmentSummaryFact = "_hw-e";
export var shipmentSummaryGrid = "_hw-d";
export var shipmentSummaryMetadataRow = "_hw-f";
export var shipmentSummaryTags = "_hw-g";
export var shipmentWorkspace = "_hw-0";
export var shipmentWorkspaceContent = "_hw-6";
export var shipmentWorkspaceHeader = "_hw-1";